import { render, staticRenderFns } from "./kefuFixed.vue?vue&type=template&id=a362acde&scoped=true"
import script from "./kefuFixed.vue?vue&type=script&lang=js"
export * from "./kefuFixed.vue?vue&type=script&lang=js"
import style0 from "./kefuFixed.vue?vue&type=style&index=0&id=a362acde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a362acde",
  null
  
)

export default component.exports